/**
 * Whether the server has said this account is turned off (403 `user_deactivated`
 * on any call). Set by lib/api.ts, read by the access gate in main.tsx. Client
 * state on purpose: it is a fact about this tab's session, learned from whichever
 * request noticed first, and it never turns back on without a page load.
 */

import { create } from "zustand";

interface AccessState {
  deactivated: boolean;
  markDeactivated: () => void;
}

export const useAccessStore = create<AccessState>((set) => ({
  deactivated: false,
  markDeactivated: () => set({ deactivated: true }),
}));
